<template>
  <div>
    <iframe :src="'static_wap/pdfjs/web/viewer.html?file='+source" ></iframe>
    <footer>
      <div class="remind">
        <img src="@/assets/imgs/pdf.png" alt="">
        <span>下载文档，方便阅读</span>
      </div>
        <div class="download" @touchstart.stop.prevent="download" @click="download">
          <span>点击下载</span>
        </div>
        <div v-show="isShow" class="toast">
          <span >下载成功</span>
        </div>
    </footer>
  </div>
</template>

<script>
import https from '../../https.js'
export default {
  props:["source"],
  data () {
    return {
      isShow:false,
    }
  },
  created(){
   
    var n=sessionStorage.getItem("pdf");
     console.log(n)
    if(n==null){
      n=1;
    }else{
      n++;
    }
    sessionStorage.setItem("pdf",n)
  },
  mounted () {

  },
  methods:{

    //点击下载pdf
    
    download(){
      var url=this.baseURl+'Article/downPdf'+'?source_path='+encodeURIComponent(this.source);
      window.location.href=url;
    }
  },
  components: {
  },
  computed:{
  },
  watch:{
  }
}

</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    iframe{
      width:100%;
      height:100vh;
    }
    footer{
      width:90%;
      height:50px;
      /* padding: 7px 35px; */
      background: rgba(0,0,0,0.5);
      position: absolute;
      bottom:2vw;
      left:5%;
      border-radius:8px;
      display: flex;
      justify-content: space-around;
      align-items: center;
      color: #fff;
    }
    .remind{
       font-size:15px;
       display: flex;
       align-items: center;
    }
    img{
      width:30px;
      margin-right:7px;
    }
    .download{
      cursor: pointer;
      width:74px;
      height:25px;
      line-height: 25px;
      border-radius: 5px;
      background:#FC3F4E;
      font-size:12px;
    }
    .toast{
      position: fixed;
      top:50%;
      left:50%;
      width:120px;
      height:50px;
      margin-left: -60px;
      margin-top: -25px;
      line-height: 50px;
      border-radius: 5px;
      background: rgba(0,0,0,0.5);
      font-size:12px;
    }
</style>



// WEBPACK FOOTER //
// src/components/common/document.vue